"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SKATTEETATEN_SITE_ID = exports.MATOMO_SERVER_URLS = exports.MATOMO_CUSTOM_DIMENSION_IDS = void 0;
const SKATTEETATEN_SITE_ID = exports.SKATTEETATEN_SITE_ID = 20;
const MATOMO_CUSTOM_DIMENSION_IDS = exports.MATOMO_CUSTOM_DIMENSION_IDS = {
  BRUKEROPPGAVE: 1,
  FIKK_DET_TIL: 2,
  SKYRA_SESSION_ID: 3
};
const MATOMO_SERVER_URLS = exports.MATOMO_SERVER_URLS = {
  test: 'https://wta-test.sits.no/matomo',
  prod: 'https://wta.sits.no/matomo'
};